import { Group, Text } from "@mantine/core";

import classes from "../MessageBubble.module.css";

// The metadata row of the dead-air suggestion card. It is a sibling of the message body rather than
// a child, but the two share one background (see .deadAirAssistHeader) so the card reads as a single
// surface - this is not a banner, and it must not grow one.
export function DeadAirAssistHeader() {
    return (
        <Group className={classes.deadAirAssistHeader} gap="xs">
            {/* Set apart from anything else that lands in this row by weight alone. It deliberately
                shares the row's muted colour so the suggestion body stays the loudest thing on the
                card - a mid-call suggestion should be findable, not attention-grabbing. */}
            <Text size="sm" fw={700}>
                Suggested
            </Text>
        </Group>
    );
}
